var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-rating"},[_c('span',{staticClass:"c-rating--fill",style:('width:' + _vm.percent + '%'),attrs:{"data-js-test":"rating-fill"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }